module.exports = ".div-scroll{\r\n    height: 330px;\r\n    overflow-y: auto;\r\n}\r\n.table th {\r\n    border-top: 0px solid #eceeef;\r\n}\r\ntr.bottom-pad td {\r\n    padding-bottom:0px;\r\n}\r\n.tspan{\r\n    color: #333333;\r\n    font-size: 18px;\r\n    fill: #333333;\r\n    font-weight: 500;\r\n}\r\n.margin-top{\r\n    margin-top: 20px;\r\n}\r\n.margin-right{\r\n    margin-right: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/renewal-reports/renewal-reports.component.css
// module id = ./src/app/modules/dashboard/renewal-reports/renewal-reports.component.css
// module chunks = main